<div class="flex items-center justify-center dialog-header ">
    {{ type }} Client

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="dialog-content">
    <form [formGroup]="clientForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">

        <!-- Name -->
        <div class="flex flex-col">
            <label for="name" class="mb-2 font-semibold">Name *</label>
            <input pInputText id="name" formControlName="name"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            <div *ngIf="clientForm.get('name')?.invalid && (clientForm.get('name')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Name is required.
            </div>
        </div>

        <!-- Bot Client ID -->
        <div class="flex flex-col">
            <label for="bot_client_id" class="mb-2 font-semibold">Bot Client ID</label>
            <input pInputText id="bot_client_id" formControlName="bot_client_id"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
        </div>

        <!-- Description -->
        <div class="flex flex-col">
            <label for="description" class="mb-2 font-semibold">Description</label>
            <input pInputText id="description" formControlName="description"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
        </div>

        <!-- Logo -->
        <div class="flex flex-col">
            <label for="logo" class="mb-2 font-semibold">Logo</label>
            <input pInputText id="logo" formControlName="logo"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
        </div>

        <!-- Status -->
        <div class="flex flex-col">
            <label for="status" class="mb-2 font-semibold">Status *</label>
            <p-select id="status" [options]="statusOptions" formControlName="status" placeholder="Select a status"
                class="w-full" />
            <div *ngIf="clientForm.get('status')?.invalid && (clientForm.get('status')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Status is required.
            </div>
        </div>

        <!-- Total User -->
        <div class="flex flex-col">
            <label for="total_user" class="mb-2 font-semibold">Total User *</label>
            <input pInputText type="number" id="total_user" formControlName="total_user"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                <div *ngIf="clientForm.get('total_user')?.invalid && (clientForm.get('total_user')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Total User is required.
            </div>
        </div>


        <div class="flex flex-col col-span-2">
            <label class="mb-2 font-semibold">Lead Channels *</label>
            <div formArrayName="leadChannels" class="flex flex-wrap gap-4">
                <div *ngFor="let channel of leadChannelsList; let i = index" class="flex items-center">
                    <p-checkbox [inputId]="'lead-' + i" [formControlName]="i" [binary]="true"></p-checkbox>
                    <label [for]="'lead-' + i" class="ml-2">{{ channel }}</label>
                </div>
            </div>
             <!-- Validation message -->
  <div *ngIf="clientForm.get('leadChannels')?.invalid && (clientForm.get('leadChannels')?.touched || submitted)"
       class="text-red-500 text-xs mt-1">
    At least one lead channel must be selected.
  </div>
        </div>

         <!-- <div class="flex flex-col col-span-2">
            <label class="mb-2 font-semibold">Feature Modules</label>
            <div formArrayName="feature_modules" class="flex flex-wrap gap-4">
                <div *ngFor="let module of featureModulesList; let i = index" class="flex items-center">
                    <p-checkbox [inputId]="'feature-' + i" [formControlName]="i" [binary]="true"></p-checkbox>
                    <label [for]="'feature-' + i" class="ml-2">{{ module | titlecase }}</label>
                </div>
            </div>
        </div> -->


        <!-- Submit Button -->
        <div class="col-span-2 flex justify-end mt-6">
            <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
                [disabled]="clientForm.invalid || isLoading"></p-button>
        </div>

    </form>
</div>